
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[orderMethod]/[venueXRefID]/checkout",
      function () {
        return require("private-next-pages/[orderMethod]/[venueXRefID]/checkout.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[orderMethod]/[venueXRefID]/checkout"])
      });
    }
  